import React from 'react';
import { z } from 'zod';

import { useRenderLiquidTemplate } from '@wp-block-builder/stores/WaypointRendererStore';

import defineBlock from './helpers/defineBlock';

export const HeadingBlockSchema = defineBlock(
  'Heading',
  z.object({
    level: z.enum(['h1', 'h2', 'h3']).nullish(),
    text: z.string().nullish(),
  })
);
export type THeadingBlock = z.infer<typeof HeadingBlockSchema>;

function getLevelStyle(level: 'h1' | 'h2' | 'h3') {
  switch (level) {
    case 'h1':
      return { fontWeight: 'inherit', margin: 0, fontSize: '32px' };
    case 'h2':
      return { fontWeight: 'inherit', margin: 0, fontSize: '24px' };
    case 'h3':
      return { fontWeight: 'inherit', margin: 0, fontSize: '20px' };
  }
}

function getLevelTag(level: 'h1' | 'h2' | 'h3') {
  switch (level) {
    case 'h1':
      return 'h1';
    case 'h2':
      return 'h2';
    case 'h3':
      return 'h3';
  }
}

type HeadingBlockProps = {
  block: THeadingBlock;
  placeholder?: JSX.Element;
  skipLiquid: boolean;
};
export default function HeadingBlock({ block, placeholder, skipLiquid }: HeadingBlockProps) {
  const text = block.props?.text ?? '';
  const level = block.props?.level ?? 'h2';

  const children = useRenderLiquidTemplate({ template: text, skipLiquid });
  if (children.trim().length === 0) {
    return placeholder ?? null;
  }

  const style = getLevelStyle(level);
  const ComponentTag = getLevelTag(level);
  return <ComponentTag style={style}>{children}</ComponentTag>;
}
